var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorBasicDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.306,
    height: 168.026,
    viewBox: "0 0 257.306 168.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3548"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3510"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12659",
    d: "m747.709 690.814-.592-.878q1.312-.884 2.605-1.794l.609.866q-1.301.916-2.622 1.806z",
    transform: "translate(-649.487 -637.947)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12675",
    d: "M825.5 618H817v27.7a9.012 9.012 0 0 1-9 9H595.75v4.066a10.067 10.067 0 0 0 10.058 10.058H825.5a10.067 10.067 0 0 0 10.058-10.058v-30.7A10.067 10.067 0 0 0 825.5 618z",
    transform: "translate(-578.249 -604.938)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12676",
    d: "M792.437 593.323H572.748a10.067 10.067 0 0 0-10.058 10.058v30.7a10.067 10.067 0 0 0 10.058 10.058h219.689a10.067 10.067 0 0 0 10.063-10.054v-30.7a10.067 10.067 0 0 0-10.058-10.058zm9 40.762a9.012 9.012 0 0 1-9 9H572.748a9.012 9.012 0 0 1-9-9v-30.7a9.012 9.012 0 0 1 9-9h219.689a9.012 9.012 0 0 1 9 9z",
    transform: "translate(-562.69 -593.323)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12677",
    d: "M639.461 609.326a16.94 16.94 0 1 0 16.94 16.94 16.94 16.94 0 0 0-16.94-16.94z",
    transform: "translate(-590.848 -600.855)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12678",
    d: "M836.321 660.8H715.095a4.235 4.235 0 1 1 0-8.47h121.226a4.235 4.235 0 1 1 0 8.47z",
    transform: "translate(-632.423 -621.092)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12679",
    d: "M775.443 626.8h-60.348a4.235 4.235 0 1 1 0-8.47h60.348a4.235 4.235 0 1 1 0 8.47z",
    transform: "translate(-632.423 -605.09)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 395",
    d: "M646.481 642.162a2.017 2.017 0 0 1-1.214-.4l-.022-.016-4.573-3.5a2.032 2.032 0 1 1 2.473-3.225l2.962 2.271 7-9.131a2.031 2.031 0 0 1 2.848-.376l-.043.06.045-.06a2.034 2.034 0 0 1 .376 2.848l-8.233 10.735a2.032 2.032 0 0 1-1.616.792z",
    transform: "translate(-599.016 -609.344)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3509"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12662",
    d: "M873.739 415.647q-.238-2.138-.519-4.263l1.424-.189q.283 2.14.523 4.293z",
    transform: "translate(-700.266 -255.962)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12680",
    d: "M909.357 333h-1.523q.043.463.043.948v41.666a12.23 12.23 0 0 1-12.213 12.212H752.75v.489c0 .316.014.632.036.948a13.652 13.652 0 0 0 13.613 12.7h142.958a13.661 13.661 0 0 0 13.649-13.649v-41.662A13.661 13.661 0 0 0 909.357 333z",
    transform: "translate(-666.339 -233.941)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12681",
    d: "M903.91 328.024a13.652 13.652 0 0 0-13.614-12.7H747.339a13.662 13.662 0 0 0-13.649 13.649v41.666a13.662 13.662 0 0 0 13.649 13.649H890.3a13.662 13.662 0 0 0 13.649-13.649v-41.667a15.81 15.81 0 0 0-.039-.948zm-1.4 42.614a12.23 12.23 0 0 1-12.21 12.213H747.339a12.23 12.23 0 0 1-12.213-12.212v-41.667a12.23 12.23 0 0 1 12.213-12.212H890.3a12.224 12.224 0 0 1 12.169 11.264q.043.463.043.948z",
    transform: "translate(-660.972 -228.962)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12682",
    d: "M871.339 383.82h-70.4a5.747 5.747 0 0 1 0-11.494h70.4a5.747 5.747 0 1 1 0 11.494z",
    transform: "translate(-678.292 -245.015)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12683",
    d: "M849.788 349.82h-48.85a5.747 5.747 0 0 1 0-11.494h48.85a5.747 5.747 0 0 1 0 11.494z",
    transform: "translate(-678.292 -235.44)",
    style: {
      fill: "#ccc"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorBasicDetails);
export default __webpack_public_path__ + "static/media/VendorBasicDetails.d532dc8fc0f01ab82c8689bd71e859a3.svg";
export { ForwardRef as ReactComponent };